/**
 * Contact Us Form Handler for /pages/contact
 * Handles the specific contact form on the contact us page
 */

document.addEventListener('DOMContentLoaded', function () {
  const netlifyFunctionUrl = 'https://orvizoho.netlify.app/.netlify/functions/contact-us';

  // Global submission tracking
  const submissionTracker = {
    activeSubmissions: new Set(),
    isSubmitting: function (formId) {
      return this.activeSubmissions.has(formId);
    },
    startSubmission: function (formId) {
      this.activeSubmissions.add(formId);
    },
    endSubmission: function (formId) {
      this.activeSubmissions.delete(formId);
    }
  };

  function initContactUsForm() {
    // EXCLUSION: Do not run on collection pages (handled by shopify-collection-form.js)
    const currentPath = window.location.pathname;
    const collectionPages = [
      '/pages/spring-collection', '/pages/arai-collection', '/pages/new-collection',
      '/pages/arazzi-collection', '/pages/florim-collection', '/pages/tesserae-collection',
      '/pages/tarkashi-collection', '/pages/palacio-collection', '/pages/lines-collection',
      '/pages/thikri-art-collection', '/pages/lippan-collection', '/pages/enigma-collection',
      '/pages/filo-collection', '/pages/brise-collection', '/pages/raku-collection',
      '/pages/bauhaus-collection', '/pages/haute-couture-collection', '/pages/blazon-collection',
      '/pages/armatura-collection', '/pages/flora-collection', '/pages/skin-collection',
      '/pages/molecules-collection', '/pages/supernova-collection', '/pages/fessura-collection',
      '/pages/tressage-collection', '/pages/filigree-collection', '/pages/sahara-collection',
      '/pages/moment-collection', '/pages/kirigami-collection', '/pages/flow-collection',
      '/pages/elementa-collection', '/pages/glyph-collection', '/pages/trenza-collection',
      '/pages/nuages-collection', '/pages/veins-collection', '/pages/solid-stone'
    ];

    if (collectionPages.includes(currentPath)) {
      console.log('On a collection page, skipping contact-us script initialization.');
      return;
    }

    // Handle BOTH contact forms (since there are 2 with same ID)
    // Also include home_project_form for "Tell us about your project" popup
    const allContactForms = [
      ...document.querySelectorAll('form[action="/contact#contact_contact_form"]'),
      ...document.querySelectorAll('form[action="/contact#ContactForm"]'),
      ...document.querySelectorAll('form#ContactForm'),
      ...document.querySelectorAll('form#home_project_form'),
      ...document.querySelectorAll('form[action*="/contact#home_project_form"]'),
      ...document.querySelectorAll('.contact-form form')
    ];

    // Remove duplicates based on form content/structure
    const uniqueForms = [];
    allContactForms.forEach(form => {
      if (!uniqueForms.find(existing => existing.isEqualNode(form))) {
        https://orvi.com/collections/all-products/products/round-wood-table-with-brass-inlay
        uniqueForms.push(form);
      }
    });

    console.log(`Found ${uniqueForms.length} unique contact forms to handle`);

    uniqueForms.forEach((contactForm, index) => {
      // Check if form is already handled by any script
      if (contactForm.hasAttribute('data-contact-us-handled') ||
        contactForm.hasAttribute('data-orvi-handled') ||
        contactForm.hasAttribute('data-handled')) {
        console.log(`Form ${index} already handled, skipping`);
        return;
      }

      // Exclude forms that should be handled by hometellus script
      // Hometellus forms have BOTH Company field AND Message field
      const hasCompanyField = contactForm.querySelector('input[name="contact[Company]"]');
      const hasMessageField = contactForm.querySelector('textarea[name="contact[Message]"]');
      const isHometellusForm = hasCompanyField && hasMessageField;

      if (isHometellusForm) {
        console.log(`Form ${index} appears to be a hometellus form (has Company + Message), skipping for contact-us script`);
        return;
      }

      console.log(`Initializing contact form ${index}:`, {
        id: contactForm.id,
        action: contactForm.action,
        className: contactForm.className
      });

      setupSingleContactForm(contactForm, index);
    });
  }

  function setupSingleContactForm(contactForm, formIndex) {
    // Inject City field if missing (User Request: Add City Under the email)
    const emailInput = contactForm.querySelector('input[name="contact[email]"]');
    const cityInputExists = contactForm.querySelector('input[name="contact[city]"], input[name="contact[City]"]');

    if (emailInput && !cityInputExists) {
      console.log('Injecting City field into Contact Us form');
      const cityWrapper = document.createElement('div');
      cityWrapper.className = 'field'; // Common Shopify class
      // Try to match the class of the email input's container
      if (emailInput.parentElement.classList.contains('field') || emailInput.parentElement.classList.contains('grid__item')) {
        cityWrapper.className = emailInput.parentElement.className;
      }

      cityWrapper.innerHTML = `
        <input type="text" 
               id="ContactFormCity-${formIndex}" 
               name="contact[city]" 
               placeholder="City" 
               class="${emailInput.className}" 
               aria-label="City"
               required>
        <label class="field__label" for="ContactFormCity-${formIndex}" style="${emailInput.nextElementSibling?.tagName === 'LABEL' ? '' : 'display:none'}">City</label>
      `;

      // Insert after the email input's parent (if wrapped) or after the email input itself
      if (emailInput.closest('.field') || emailInput.closest('.grid__item') || emailInput.closest('.input-group')) {
        emailInput.closest('.field, .grid__item, .input-group').after(cityWrapper);
      } else {
        emailInput.after(cityWrapper);
      }
    }

    // Generate unique form ID for tracking (make it truly unique)
    const formId = contactForm.id ? `${contactForm.id}-${formIndex}` : `contact-form-${formIndex}-${Date.now()}`;

    // Don't change the actual form ID as it might break other scripts
    // contactForm.id = formId;

    // Find form fields
    const fieldMappings = {
      firstName: contactForm.querySelector('input[name="contact[first_name]"]'),
      lastName: contactForm.querySelector('input[name="contact[last_name]"]'),
      email: contactForm.querySelector('input[name="contact[email]"]'),
      phone: contactForm.querySelector('input[name="contact[phone]"]'),
      city: contactForm.querySelector('input[name="contact[City]"]') || contactForm.querySelector('input[name="contact[city]"]'),
      address: contactForm.querySelector('input[name="contact[Address]"]'),
      requestType: contactForm.querySelector('select[name="contact[request_type]"]'),
      message: contactForm.querySelector('textarea[name="contact[body]"]') || contactForm.querySelector('textarea[name="contact[Message]"]'),
      formNameField: contactForm.querySelector('input[name="contact[Form Name]"]')
    };

    // Validate required fields are present (only check core required fields)
    const missingFields = [];
    if (!fieldMappings.firstName) missingFields.push('firstName');
    if (!fieldMappings.lastName) missingFields.push('lastName');
    if (!fieldMappings.email) missingFields.push('email');
    if (!fieldMappings.phone) missingFields.push('phone');
    // City is now mandatory, but if the form doesn't have the field yet, we shouldn't break existing forms if they aren't updated in Liquid. 
    // However, the user says "Add City... Mandatory All Form". I will warn if missing but proceed if not found (user might update liquid later)
    if (!fieldMappings.city) console.warn('City field not found in form');

    if (missingFields.length > 0) {
      console.error('Contact form missing required fields:', missingFields);
      console.log('Available form elements:', contactForm.innerHTML);
      return;
    }

    console.log('Contact form initialized successfully:', {
      formId: contactForm.id,
      action: contactForm.action,
      hasFirstName: !!fieldMappings.firstName,
      hasLastName: !!fieldMappings.lastName,
      hasEmail: !!fieldMappings.email,
      hasPhone: !!fieldMappings.phone
    });

    // Remove any existing event listeners to prevent duplicates
    if (contactForm._orviContactHandler) {
      contactForm.removeEventListener('submit', contactForm._orviContactHandler);
    }

    const submitHandler = async function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      // Check if already submitting
      if (submissionTracker.isSubmitting(formId)) {
        return;
      }

      // Start tracking submission
      submissionTracker.startSubmission(formId);

      // Disable form interactions during submission
      this.style.pointerEvents = 'none';

      // Get form data
      // Detect form type based on form ID or Form Name hidden field
      const formNameValue = fieldMappings.formNameField?.value || '';
      const isHomepageAppointment = formNameValue === 'Appointments';
      const isGetInTouchForm = this.id === 'home_project_form' || formNameValue === 'Get in Touch';

      // Determine appropriate lead source and form name
      let formName, leadSource, sourceByGroup;
      if (isGetInTouchForm) {
        formName = 'Get in Touch';
        leadSource = 'Get in Touch';
        sourceByGroup = 'Get in Touch';
      } else if (isHomepageAppointment) {
        formName = 'Schedule A Call';
        leadSource = 'Schedule A Call';
        sourceByGroup = 'Schedule A Call';
      } else {
        formName = 'Contact us';
        leadSource = 'Contact us';
        sourceByGroup = 'Contact us';
      }

      console.log('Contact form submission:', {
        formId: this.id,
        action: this.action,
        formNameValue: formNameValue,
        isGetInTouchForm: isGetInTouchForm,
        isHomepageAppointment: isHomepageAppointment,
        leadSource: leadSource
      });

      const formData = {
        firstName: (fieldMappings.firstName?.value || '').trim(),
        lastName: (fieldMappings.lastName?.value || '').trim(),
        email: (fieldMappings.email?.value || '').trim(),
        phone: (fieldMappings.phone?.value || '').trim(),
        city: (fieldMappings.city?.value || '').trim(),
        address: (fieldMappings.address?.value || '').trim(),
        request_type: (fieldMappings.requestType?.value || 'General Inquiry').trim(),
        body: (fieldMappings.message?.value || '').trim(),
        formName: formName,
        leadSource: leadSource,
        sourceByGroup: sourceByGroup
      };

      console.log('Form field mappings found:', {
        hasFirstName: !!fieldMappings.firstName,
        hasLastName: !!fieldMappings.lastName,
        hasEmail: !!fieldMappings.email,
        hasPhone: !!fieldMappings.phone,
        hasCity: !!fieldMappings.city,
        hasAddress: !!fieldMappings.address,
        hasRequestType: !!fieldMappings.requestType,
        hasMessage: !!fieldMappings.message,
        hasFormNameField: !!fieldMappings.formNameField,
        formNameValue: fieldMappings.formNameField?.value
      });

      // Validate required fields
      const emptyFields = [];
      if (!formData.firstName) emptyFields.push('First Name');
      if (!formData.lastName) emptyFields.push('Last Name');
      if (!formData.email) emptyFields.push('Email');
      if (!formData.phone) emptyFields.push('Phone');
      if (!formData.city) emptyFields.push('City');
      // Message is now optional
      // if (!formData.body) emptyFields.push('Message'); 

      if (emptyFields.length > 0) {
        alert(`Please fill in the following required fields: ${emptyFields.join(', ')}`);
        submissionTracker.endSubmission(formId);
        this.style.pointerEvents = '';
        return;
      }

      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        alert('Please enter a valid email address.');
        submissionTracker.endSubmission(formId);
        this.style.pointerEvents = '';
        return;
      }

      // Show loading state
      const submitBtn = this.querySelector('button[type="submit"], input[type="submit"]');
      const originalText = submitBtn ? (submitBtn.innerHTML || submitBtn.value) : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        if (submitBtn.tagName === 'BUTTON') {
          submitBtn.innerHTML = 'SUBMITTING...';
        } else {
          submitBtn.value = 'SUBMITTING...';
        }
      }

      console.log('Submitting form data to Netlify:', formData);
      console.log('Netlify function URL:', netlifyFunctionUrl);

      try {
        const response = await fetch(netlifyFunctionUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(formData),
        });

        console.log('Response received:', {
          status: response.status,
          statusText: response.statusText,
          ok: response.ok
        });

        let result;
        try {
          result = await response.json();
        } catch (parseError) {
          throw new Error('Invalid response from server');
        }

        if (response.ok && result.success) {
          console.log('Form submitted successfully:', result);

          // Show success message
          if (result.duplicate) {
            alert('Your contact information has already been submitted!');
          } else {
            alert('Thank you! Your message has been sent successfully. We will get back to you soon.');
          }

          this.reset();

          // Show success state on button temporarily
          if (submitBtn) {
            if (submitBtn.tagName === 'BUTTON') {
              submitBtn.innerHTML = 'SENT!';
            } else {
              submitBtn.value = 'SENT!';
            }
          }
        } else {
          console.error('Form submission failed:', {
            status: response.status,
            statusText: response.statusText,
            result: result
          });
          alert('There was an error sending your message. Please try again later.');
        }
      } catch (error) {
        console.error('Contact form submission error:', error);
        alert('Network error. Please check your connection and try again.');
      } finally {
        // Always restore form state
        submissionTracker.endSubmission(formId);
        this.style.pointerEvents = '';

        if (submitBtn) {
          setTimeout(() => {
            if (submitBtn.tagName === 'BUTTON') {
              submitBtn.innerHTML = originalText;
            } else {
              submitBtn.value = originalText;
            }
            submitBtn.disabled = false;
          }, 2000);
        }
      }
    };

    // Store handler reference and add event listener
    contactForm._orviContactHandler = submitHandler;
    contactForm.addEventListener('submit', submitHandler);
    contactForm.setAttribute('data-contact-us-handled', 'true');

    console.log(`Contact form ${formIndex} initialized successfully`);
  } // End of setupSingleContactForm function

  // Setup appointment link handler for homepage popup
  const setupAppointmentLinks = () => {
    const appointmentLinks = document.querySelectorAll('a.appointment, .appointment a, a[href*="appointment"], button.appointment');
    appointmentLinks.forEach(link => {
      link.removeEventListener('click', handleAppointmentClick);
      link.addEventListener('click', handleAppointmentClick);
    });
  };

  const handleAppointmentClick = () => {
    // Wait for popup to appear and reinitialize form
    setTimeout(() => {
      initContactUsForm();
    }, 100);
    setTimeout(() => {
      initContactUsForm();
    }, 500);
  };

  // Initialize the form
  initContactUsForm();
  setupAppointmentLinks();

  // Also try again after a delay in case the forms load dynamically
  setTimeout(() => {
    initContactUsForm();
    setupAppointmentLinks();
  }, 1000);

  // Watch for dynamic content changes
  const observer = new MutationObserver(() => {
    setTimeout(() => {
      initContactUsForm();
      setupAppointmentLinks();
    }, 100);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});